import { FilterData, FilterValue } from '@nexelem/filters';
import { SimulationFiltersData } from './SimulationFilters';

export type SimulationFilters = {
  search?: string;
  queueId?: string;
  queueAreaId?: string;
  productionStartFromDateTime?: string;
  productionStartToDateTime?: string;
};

export const simulationFiltersMapper = (filters: FilterData<SimulationFiltersData>): SimulationFilters => {
  const queueIds = filters.queueId?.value as FilterValue[];
  const areaIds = filters.queueAreaId?.value as FilterValue[];
  const plannedDateRange = filters.plannedDateRange?.value as { from?: Date; to?: Date };
  const searchValue = filters.search?.value as string;

  return {
    search: searchValue && searchValue.trim() ? searchValue : undefined,
    queueId: queueIds?.length ? queueIds[0]?.value?.toString() : undefined,
    queueAreaId: areaIds?.length ? areaIds[0]?.value?.toString() : undefined,
    productionStartFromDateTime: plannedDateRange?.from ? plannedDateRange.from.toISOString() : undefined,
    productionStartToDateTime: plannedDateRange?.to ? plannedDateRange.to.toISOString() : undefined,
  };
};
